{
  "id": "campaign-134",
  "name": "Unkempt Bowl",
  "seed": "campaign:134",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r,,,,~QQQQ,,,,,r",
    ",,,:,~~....,:...",
    ",,,:,~..,,,,:...",
    ",,,::::::::::...",
    ",,,,,,a,,a,,,,,,",
    ",,,,,,,,,,,,,,,,",
    ",,,,,,,,x,,,,,,,",
    ",,,,,,,,,,,,,,,,",
    ",,,,,,,,,,,,,,,,",
    "::::::::::::::::",
    ",a~a,,a,,a,,a.a.",
    ",~~~...,,,,,,...",
    ",,~,...,,,,,,...",
    "...~.x.,,,,,#,,,",
    "..~::::::::::,,,",
    "..a:,,,,,,,,:a,,",
    "...:,,,,,,,,:,..",
    "....,,QQQQ,,...S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 1,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 13,
      "y": 11
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 3
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 13,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 0,
      "y": 3
    },
    {
      "kind": "gas",
      "x": 6,
      "y": 13
    },
    {
      "kind": "gas",
      "x": 4,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 1
    }
  ],
  "balls": {
    "first": 18,
    "every": 12
  },
  "generatorVersion": 3,
  "level": 134,
  "biome": "stadium",
  "par": {
    "reel": 10711,
    "push": 9319,
    "selfPropelled": 8301,
    "tractor": 7265,
    "zeroTurn": 5998,
    "fairway": 3450
  },
  "goldTime": {
    "reel": 10505,
    "push": 9319,
    "selfPropelled": 7965,
    "tractor": 7028,
    "zeroTurn": 5998,
    "fairway": 3184
  },
  "routeTries": {
    "par": {
      "reel": 23,
      "push": 15,
      "selfPropelled": 0,
      "tractor": 7,
      "zeroTurn": 4,
      "fairway": 21
    },
    "gold": {
      "reel": 25,
      "push": 15,
      "selfPropelled": 25,
      "tractor": 28,
      "zeroTurn": 4,
      "fairway": 40
    }
  }
}
